export const CHATROOM_SERVICE_PRIVILEGES = [
    "CHATROOM_MANAGE",
    "CHATROOM_OBSERVE",
];

export const normalizeServiceCode = (code) =>
    String(code || "").trim().toUpperCase();

export const getUserPrivilegeCodes = (user) =>
    String(user?.servicePrivilege || "")
        .split(",")
        .map(normalizeServiceCode)
        .filter(Boolean);

export const getUserServiceCodes = (user) =>
    (user?.services || [])
        .map((service) => normalizeServiceCode(service.serviceCode || service.service_code))
        .filter(Boolean);

export const hasAnyServicePrivilege = (user, allowedCodes) => {
    const privilegeCodes = getUserPrivilegeCodes(user);
    const serviceCodes = getUserServiceCodes(user);
    const allowed = allowedCodes.map(normalizeServiceCode);

    return ["ADMIN", "ALL"].includes(user?.role)
        || privilegeCodes.includes("ALL")
        || allowed.some((code) => privilegeCodes.includes(code) || serviceCodes.includes(code));
};

export const hasChatroomAccess = (user) =>
    hasAnyServicePrivilege(user, CHATROOM_SERVICE_PRIVILEGES);

export const isChatroomServiceCode = (code) =>
    CHATROOM_SERVICE_PRIVILEGES.includes(normalizeServiceCode(code));

export const resolveChatroomRoute = (service) => {
    const route = String(service?.route || "").trim();
    return route && route !== "/" ? route : "/chatrooms";
};
